import { DataDisplayEvent } from "@mcleod/components";
import { LayoutUrl } from "@mcleod/core";
import { AutogenLayoutTariffRegionQuickInfo } from "./autogen/AutogenLayoutTariffRegionQuickInfo";

export class TariffRegionQuickInfo extends AutogenLayoutTariffRegionQuickInfo {

    textboxRegionNameOnDataDisplay(event: DataDisplayEvent) {
        this.textboxRegionName.printableLabel.link = LayoutUrl.createForUpdateMode(
            "lme/dispatch/TariffRegionMaster",
            event.rowData?.get("reg_uid")
        );
    }
}
